import react, { useState } from "react";
import { TableCell, TableRow, Box, IconButton, Modal } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import ButtonGroup from "@mui/material/ButtonGroup";
import ChangeMinorModal from "./ChangeMinorModal";
import { addCommas } from "@persian-tools/persian-tools";

const MinorRow = (props) => {
	//Modal styling
	const style = {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		maxWidth: 800,
		width: "90%",
		bgcolor: "background.paper",
		border: "2px solid #000",
		boxShadow: 24,
		p: 4,
		mx: "auto",
	};

	const [openMinor, setOpenMinor] = useState(false);
	const handleOpenMinor = () => setOpenMinor(true);
	const handleCloseMinor = () => setOpenMinor(false);

	return (
		<react.Fragment>
			<Modal open={openMinor} onClose={handleCloseMinor}>
				<Box sx={style}>
					<ChangeMinorModal
						minorId={props.id}
						title={props.title}
						count={props.count}
						totalPrice={props.totalPrice}
						discountPrice={props.discountPrice}
						close={handleCloseMinor}
						open={openMinor}
					/>
				</Box>
			</Modal>

			<TableRow>
				<TableCell align="justify" colSpan={1}>
					<ButtonGroup orientation="vertical" variant="text">
						<IconButton>
							<EditIcon
								color="secondary"
								onClick={handleOpenMinor}
							/>
						</IconButton>
					</ButtonGroup>
				</TableCell>

				<TableCell colSpan={3}>{props.title}</TableCell>
				<TableCell colSpan={2}>{props.count}</TableCell>
				<TableCell align="justify">
					{addCommas(props.totalPrice)}
				</TableCell>
				<TableCell align="justify">
					{addCommas(props.discountPrice)}
				</TableCell>
			</TableRow>
		</react.Fragment>
	);
};

export default MinorRow;
